// src/components/ContactUs.jsx
import React, { useState } from 'react';
import { Container, Typography, Box, Grid, TextField, Button, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

function ContactUs() {
    const { t } = useTranslation();
    const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
    const [status, setStatus] = useState({ success: null, loading: false });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ success: null, loading: true });
        try {
            const res = await fetch('/api/contact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(form),
            });
            const data = await res.json();
            if (data.success) {
                setStatus({ success: true, loading: false });
                setForm({ name: '', email: '', subject: '', message: '' });
            } else {
                throw new Error('Send failed');
            }
        } catch (err) {
            console.error(err);
            setStatus({ success: false, loading: false });
        }
    };

    return (
        <Container maxWidth="lg">
            <Box sx={{ my: 4 }}>
                <Typography variant="h4" gutterBottom>
                    {t('contactUsTitle')}
                </Typography>
                <Typography variant="body1" paragraph>
                    {t('contactUsIntro')}
                </Typography>
                {status.success === true && <Alert severity="success">{t('contactUsSuccessMessage')}</Alert>}
                {status.success === false && <Alert severity="error">{t('contactUsErrorMessage')}</Alert>}
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label={t('contactUsNameLabel')}
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                                placeholder={t('contactUsNamePlaceholder')}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label={t('contactUsEmailLabel')}
                                name="email"
                                type="email"
                                value={form.email}
                                onChange={handleChange}
                                placeholder={t('contactUsEmailPlaceholder')}
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={t('contactUsSubjectLabel')}
                                name="subject"
                                value={form.subject}
                                onChange={handleChange}
                                placeholder={t('contactUsSubjectPlaceholder')}
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={t('contactUsMessageLabel')}
                                name="message"
                                multiline
                                rows={6}
                                value={form.message}
                                onChange={handleChange}
                                placeholder={t('contactUsMessagePlaceholder')}
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button type="submit" variant="contained" disabled={status.loading}>
                                {t('contactUsSubmitButton')}
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Container>
    );
}

export default ContactUs;